//
//
//
//
//
//
//
//
//
//
//
//
//

import urlParam from 'url-param-object';

const isAndroid = urlParam.getParamValue('system') === 'android';

export default {
  props: ['title', 'headerStyle', 'rightBtnStyle', 'leftBtnStyle'],
  data() {
    return {
      isShowHeader: false,
      heigit: isAndroid ? 56 : 44,
    };
  },

  computed: {
    navTitle() {
      if (!this.title) {
        return '无人货架';
      }
      return this.title;
    },
  },

  methods: {
    onLeftAction() {
      this.$emit('onLeftAction');
    },

    onRightAction() {
      this.$emit('onRightAction');
    },
  },

  mounted() {
    this.isShowHeader = this.$store.state.isShowHeader;
  },
};



// WEBPACK FOOTER //
// ./src/components/Header/index.vue